"use strict";
/**
 * getBidFormat returns a structure that give other functions context on where to
 * find the data they need based on which type of bid has been passed in.
 * supports "index" and "prebid"
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getBidFormat(provider) {
    if (provider === "prebid") {
        return {
            adPartner: provider,
            priceField: "cpm",
            priceIncrement: "cpm",
            requestIdField: "pbRequestId",
            responseIdField: "pbResponseId",
            bidderField: "bidderCode",
        };
    }
    else {
        throw new Error("invalid ad provider");
    }
}
exports.default = getBidFormat;
